<mat-card appearance="outlined" class="mb-4">
  @if (to.label) {
    <p class="fs-5">
      {{ to.label | translate }}
    </p>
  }
  <ng-container #fieldComponent></ng-container>
</mat-card>
